var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3134_19731",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3134_19731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 16.9436L20.3282 21.2718C20.453 21.3966 20.606 21.4632 20.7872 21.4718C20.9684 21.4804 21.1299 21.4137 21.2718 21.2718C21.4137 21.1299 21.4846 20.9726 21.4846 20.8C21.4846 20.6274 21.4137 20.4701 21.2718 20.3282L16.9436 16L21.2718 11.6718C21.3966 11.547 21.4632 11.394 21.4718 11.2128C21.4804 11.0316 21.4137 10.8701 21.2718 10.7282C21.1299 10.5863 20.9726 10.5154 20.8 10.5154C20.6274 10.5154 20.4701 10.5863 20.3282 10.7282L16 15.0564L11.6718 10.7282C11.547 10.6034 11.394 10.5368 11.2128 10.5282C11.0316 10.5196 10.8701 10.5863 10.7282 10.7282C10.5863 10.8701 10.5154 11.0274 10.5154 11.2C10.5154 11.3726 10.5863 11.5299 10.7282 11.6718L15.0564 16L10.7282 20.3282C10.6034 20.453 10.5368 20.606 10.5282 20.7872C10.5196 20.9684 10.5863 21.1299 10.7282 21.2718C10.8701 21.4137 11.0274 21.4846 11.2 21.4846C11.3726 21.4846 11.5299 21.4137 11.6718 21.2718L16 16.9436ZM16.0045 28C14.3451 28 12.785 27.6851 11.3241 27.0554C9.86331 26.4256 8.59259 25.5709 7.51197 24.4913C6.43137 23.4117 5.57589 22.1422 4.94553 20.6827C4.31518 19.2233 4 17.6638 4 16.0045C4 14.3451 4.31488 12.785 4.94463 11.3241C5.57441 9.86331 6.4291 8.59259 7.5087 7.51197C8.5883 6.43137 9.85782 5.57589 11.3173 4.94553C12.7767 4.31518 14.3362 4 15.9955 4C17.6549 4 19.215 4.31488 20.6759 4.94463C22.1367 5.57441 23.4074 6.4291 24.488 7.5087C25.5686 8.5883 26.4241 9.85782 27.0545 11.3173C27.6848 12.7767 28 14.3362 28 15.9955C28 17.6549 27.6851 19.215 27.0554 20.6759C26.4256 22.1367 25.5709 23.4074 24.4913 24.488C23.4117 25.5686 22.1422 26.4241 20.6827 27.0545C19.2233 27.6848 17.6638 28 16.0045 28ZM16 26.6667C18.9778 26.6667 21.5 25.6333 23.5667 23.5667C25.6333 21.5 26.6667 18.9778 26.6667 16C26.6667 13.0222 25.6333 10.5 23.5667 8.43333C21.5 6.36667 18.9778 5.33333 16 5.33333C13.0222 5.33333 10.5 6.36667 8.43333 8.43333C6.36667 10.5 5.33333 13.0222 5.33333 16C5.33333 18.9778 6.36667 21.5 8.43333 23.5667C10.5 25.6333 13.0222 26.6667 16 26.6667Z",
    fill: "#7F7D82"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModalIcon);
export default __webpack_public_path__ + "static/media/closeModalIcon.e6c93bbe07217084d10133de99fb4cad.svg";
export { ForwardRef as ReactComponent };